import { render, staticRenderFns } from "./FirstGuideDialog.vue?vue&type=template&id=3c356470&scoped=true&"
import script from "./FirstGuideDialog.vue?vue&type=script&lang=js&"
export * from "./FirstGuideDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c356470",
  null
  
)

export default component.exports